export default __webpack_public_path__ + "static/MongorrOrig-34c05112758a85cef69454bfbf709415.jpg";